module.exports = __webpack_public_path__ + "static/assets/cd200d8b59d5c3d4ff3a69a774f5fac3.svg";